import "./socialNetworks.scss";
import facebook from "../img/facebook.svg";
import instagram from "../img/instagram.svg";
import twitter from "../img/twitter.svg";
import { useTranslation } from "react-i18next";

import { socialLinks } from "../../utility/data";

function SocialNetworks({ eventId, orgId, compact = false }) {
  const { t } = useTranslation("eventdesc");

  const openSocial = (link) => {
    const url = eventId
      ? `https://ticket.comitty.be/events/${eventId}`
      : `https://ticket.comitty.be/takeaway/${orgId}`;

    switch (link) {
      case socialLinks.twitter:
        window.open(`https://twitter.com/intent/tweet?text=${url}`, "_blank");
        break;

      case socialLinks.facebook:
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
        break;

      case socialLinks.instagram:
        window.open(`https://www.instagram.com/comitty_app/`, "_blank");
        break;

      default:
        window.open("https://www.google.com", "_blank");
    }
  };

  return (
    <div className="__ticket-contact-social">
      <div className="__ticket-social-area">
        <div className="__ticket-social-area-title">
          <div className="title">
            {eventId ? t("share_event_on_socials") : t("share_shop_on_socials")}
          </div>
        </div>
        <div className="__ticket-social-area-buttons">
          {[
            { name: "Facebook", image: facebook, link: socialLinks.facebook },
            { name: "Instagram", image: instagram, link: socialLinks.instagram },
            { name: "Twitter", image: twitter, link: socialLinks.twitter },
          ].map((social) => compact ? (
            <button key={social.name} type="button" aria-label={social.name} onClick={() => openSocial(social.link)}>
              <img src={social.image} alt="" />
            </button>
          ) : (
            <img key={social.name} onClick={() => openSocial(social.link)} src={social.image} alt={social.name} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SocialNetworks;
